import React, { useEffect, useState } from "react";
import Joyride, { CallBackProps, Step } from "react-joyride";

type TourGuideProps = {
  run: boolean;
  setRun: React.Dispatch<React.SetStateAction<boolean>>;
};

const TourGuide = ({ run, setRun }: TourGuideProps) => {
    const [tourCompleted, setTourCompleted] = useState(
      localStorage.getItem("tourCompleted") === "true"
    );
  
    useEffect(() => {
      if (!tourCompleted) {
        setRun(true);
      }
    }, [tourCompleted, setRun]);
  
    const handleTourEnd = (data: CallBackProps) => {
      if (data.status === "finished" || data.status === "skipped") {
        localStorage.setItem("tourCompleted", "true"); 
        setTourCompleted(true);
        setRun(false); 
      }
    };

  const stepDefaults = {
    spotlightClicks: true,
    spotlightPadding: 10,
    placement: 'left' as const,
    event: 'hover' as const,
    hideFooter: false,
  };

  const steps: Step[] = [
    {
      ...stepDefaults,
      target: ".no-print",
      content: "Use this to print the page in pdf format",
    },
    {
        ...stepDefaults,
        target: ".multilineplotinfo",
        content: "This is the info tab indicating the details of the component it belongs to. In this case, it informs about the contents in the below Multi-Line Plot as well as how to update the data displayed by selecting values from the dropdown options.",
      },
      {
        ...stepDefaults,
        target: ".bg",
        content: "Click on the traces to toggle its viewing in the plot",
      },
      {
        ...stepDefaults,
        target: ".selector-rect",
        content: "Click on these buttons to update the plot data. Also you can find interactive options to the top-right of the plot once you hover on the plot.",
      },
      {
        ...stepDefaults,
        target: ".select-species",
        content: "Click on these buttons to update the plot data. Also you can find interactive options to the top-right of the plot once you hover on the plot.",
      },
      {
        ...stepDefaults,
        target: ".css-1pedu2u-MuiResponsiveChart-container",
        content: "Hover over the pie-chart to see the values",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".leaflet-container",
        content: "Hover over the highlighted sections of map to see percentage change and the species it belongs.",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".MuiButtonBase-root",
        content: "Click to see other related topics to GEMMA project",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".joyride-summary",
        content: "Click to go back to main dashboard page.",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".joyride-measurements-dashboard",
        content: "Click to view the the measurements dashboard.",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".joyride-aboutus",
        content: "Click to learn more about the GEMMA project.",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".joyride-related-links",
        content: "Click to see related institutions, research, and other information.",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".interestedforupdates",
        content: "Sign up to get updates related to data, any viable updates from GEMMA",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".registerfeedback",
        content: "After interacting with the entire website please use this button to register your feedback. This button will be discontinued after complete roll-out is finalised.",
        disableScrolling:false,
        placement: 'bottom',
      },{
        ...stepDefaults,
        target: ".signout-button",
        content: "Sign out of the account",
        disableScrolling:false,
        placement: 'bottom',
      }
  ];


  return (
    <Joyride
    steps={steps}
    run={!tourCompleted && run} 
    disableScrolling={true}
    continuous
    showProgress
    showSkipButton
    callback={handleTourEnd}
    styles={{ options: { width: 900, zIndex: 1500 } }}
    />
  );
};

export default TourGuide;
